export const ESTIMATE_TYPES_OPTIONS = [
  { label: "Head Count", value: "HEAD_COUNT" },
  { label: "Square Footage", value: "SQUARE_FOOTAGE" },
  { label: "Square Meters", value: "SQUARE_METERS" },
];

export const SCOPES_OPTIONS = [
  { label: "No Scope", value: "NO_SCOPE" },
  { label: "Scope 1", value: "scope1" },
  { label: "Scope 2", value: "scope2" },
];
